export const TOASTER_TARGET = 'b-toaster-top-right';
